document.addEventListener('DOMContentLoaded', () => {
	const zoomContainers = document.querySelectorAll('.zoom-container');

	zoomContainers.forEach(container => {
		const img = container.querySelector('.zoomable-image');

		if (!img) return;

		container.addEventListener('click', () => {
			container.classList.toggle('is-zoomed');

			// Reset transform origin when zooming out
			if (!container.classList.contains('is-zoomed')) {
				img.style.transformOrigin = 'center center';
			}
		});

		container.addEventListener('mousemove', e => {
			if (!container.classList.contains('is-zoomed')) return;

			const rect = container.getBoundingClientRect();
			const x = e.clientX - rect.left;
			const y = e.clientY - rect.top;

			const xPercent = (x / rect.width) * 100;
			const yPercent = (y / rect.height) * 100;

			img.style.transformOrigin = `${xPercent}% ${yPercent}%`;
		});

		// Reset zoom when modal is closed
		const modal = container.closest('.modal');
		if (modal) {
			modal.addEventListener('hidden.bs.modal', () => {
				container.classList.remove('is-zoomed');
				img.style.transformOrigin = 'center center';
			});
		}
	});
});
